import { useQuery } from '@tanstack/react-query';
import { ComponentType, useContext } from 'react';
import { resourcesAPI, Trigger } from '../../../api/resources';
import { ModuleContext } from '../../../components/utils/module/ModuleContext';
import { TRIGGER_ALWAYS_ON_TEXT, TRIGGER_IN_EHR_TEXT } from '../../../v2/utils/constant';
import { MODULE_TYPES } from '../../../constants';

export const DEFAULT_TRIGGERS = [TRIGGER_ALWAYS_ON_TEXT, TRIGGER_IN_EHR_TEXT];

interface Triggers {
  triggers: Trigger[];
  candidate_triggers: Trigger[];
}

export function useTriggers() {
  const { module } = useContext(ModuleContext);
  return useQuery({
    queryKey: [module?.type, module?.id, 'triggers'],
    queryFn: resourcesAPI.getTriggers,
    initialData: [],
    select: sortTriggersByPriority,
    staleTime: Infinity,
    initialDataUpdatedAt: 0,
  });
}

export function withTriggers<P extends object>(WrappedComponent: ComponentType<P>) {
  return (props: P) => {
    const { data, refetch } = useTriggers();
    return <WrappedComponent triggers={data} refetchTriggers={refetch} {...props} />;
  };
}

function sortTriggersByPriority(data: Trigger[]) {
  return data.sort((a, b) => {
    switch (true) {
      case a.title === 'Always On' && b.title !== 'Always On':
        return -1;
      case b.title === 'Always On' && a.title !== 'Always On':
        return 1;
      case a.is_global && !b.is_global:
        return -1;
      case b.is_global && !a.is_global:
        return 1;
      default:
        return a.id - b.id;
    }
  });
}
